import { useEffect, useRef, useState } from "react";
import { Card, Dropdown, Space, Table, Tooltip } from "antd";
import { useNavigate } from 'react-router-dom';
import EmployeeFilter from "../EmployeeFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { getCandidateInfoPagination } from "hooks/api/employeeApi/employeeOnboardingApi";
import { EMPLOYEE_CANDIDATE_INFO } from "constants";
import { getEmployeeDesignation } from "hooks/api/masterApi/employeeDesignationApi";
import dayjs from "dayjs";
import { EmployeeDetails } from "components/common/CommonComponent";
import {checkUserPermissionFunc} from "components/common/CommonFuntion";
import { getEmployeeAllDepartment } from "hooks/api/masterApi/employeeDepartmentApi";
import { getEmployeeGroup } from "hooks/api/masterApi/employeeGroupApi";
import { getEmployee } from "hooks/api/employeeApi/employeeInformationApi";
import IconButton from "components/ui/Button/IconButton";
import { ImagePaths } from "utils/ImagePath";
import { NEW_EMPLOYEE_CANDIDATE_INFO } from "constant";
import useApiMethods from "hooks/apiConfig/method/apiMethods";

const initialData = {
  designation_name: "",
  department_name: "",
  reporting_manager: "",
  emplyee_group: "",
  is_active: "",
  designationList: [],
  departmentlist: [],
  reportingManagerList: [],
  employeeGroupList: []
}

function EmployeeOnboardingList() {
  const query = "";
  const pageSize = 10;
  const authtoken = sessionStorage.getItem("token");
  const is_super_admin = JSON.parse(sessionStorage.getItem("is_super_admin"));
  const userPermission = checkUserPermissionFunc("employee", "Employee Onboarding", "SubMenu");
  const isEditAccess = userPermission?.add || is_super_admin
  const [pageNo, setPageNo] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState("");
  const [dataUpdated, setDataUpdated] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const tableContainerHeight = "72vh";
  let queryRef = useRef("");

  const navigate = useNavigate();

  // const userPermission = checkUserPermissionFunc("employee", "Employees", "SubMenu");

  /*call designation*/
  const getEmployeeDesignationList = async () => {
    try {
      const apiData = await getEmployeeDesignation(`drop_down=True`);
      if (apiData && apiData.status === "success" && apiData.data) {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          designationList: [...apiData.data]
        }))
      } else {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          designationList: []
        }))
      }
    } catch (error) {
      setFilterDatas((prevFilterData) => ({
        ...prevFilterData,
        designationList: []
      }))
    }
  }

  /*call departments*/
  const getDepartmentList = async () => {
    try {
      const apiData = await getEmployeeAllDepartment(`drop_down=True`);
      if (apiData && apiData.status === "success" && apiData.data) {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          departmentlist: [...apiData.data]
        }))
      } else {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          departmentlist: []
        }))
      }
    } catch (error) {
      setFilterDatas((prevFilterData) => ({
        ...prevFilterData,
        departmentlist: []
      }))
    }
  }

  /*call employee group*/
  const getEmpGrpList = async () => {
    try {
      const apiData = await getEmployeeGroup(`drop_down=True`);
      if (apiData && apiData.status === "success" && apiData.data) {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          employeeGroupList: [...apiData.data]
        }))
      } else {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          employeeGroupList: []
        }))
      }
    } catch (error) {
      setFilterDatas((prevFilterData) => ({
        ...prevFilterData,
        employeeGroupList: []
      }))
    }
  }

  // call Reporting Manager
  const getReportingManagerList = async () => {
    try {
      const apiData = await getEmployee(`drop_down=True`);
      if (apiData && apiData.status === "success" && apiData.data) {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          reportingManagerList: [...apiData.data]
        }))
      } else {
        setFilterDatas((prevFilterData) => ({
          ...prevFilterData,
          reportingManagerList: []
        }))
      }
    } catch (error) {
      setFilterDatas((prevFilterData) => ({
        ...prevFilterData,
        reportingManagerList: []
      }))
    }
  };

  useEffect(() => {
    getDepartmentList();
    getEmpGrpList();
    getEmployeeDesignationList();
    getReportingManagerList();
  }, [])

  // const [data, pageInfo, loading, _message, refetch] = useApiData(getCandidateInfoPagination, {
  //   pageNo,
  //   pageSize,
  //   query,
  //   searchText,
  //   sorting
  // });

  // useEffect(() => {
  //   if (_message && _message.isErrorMsg && _message.errorMsgText) {
  //     ToastMsg('error', _message.errorMsgText);
  //   }
  // }, [_message.errorMsgText]);

  const { fetch, update } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ pageNo: '', pageSize: '', query: '', search: '', sorting: '' })

  const fetchEmpOnboardingData = async () => {
    const response = await fetch(NEW_EMPLOYEE_CANDIDATE_INFO, filter, setLoading);
    if (response?.status) {
      setData(response?.data?.result);
      setPageInfo({
        pageNo: response.data.page_no,
        pageSize: response.data.page_size,
        totalCount: response.data.total_count,
        noOfPages: response.data.no_of_pages,
      });
    }
  };

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
    fetchEmpOnboardingData();
  }, [filter, authtoken]);

  const addClick = () => {
    navigate('/employee/employeeonboarding/add',
      {
        state: {
          fromEdit: false,
          id: null,
          departmentId: null,
          designationId: null,
          designation_name: null
        }
      });
  };

  const handleSearch = () => {
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: 1,
      pageSize: pageSize || prevFilter.pageSize,
      query: queryString,
      search: searchText,
      sorting: sorting,
    }));
    setDataUpdated(!dataUpdated);
  }

  const handleClick = (empData, key) => {
    navigate('/employee/employeeonboarding/add',
      {
        state: {
          fromEdit: true,
          id: empData.employee_details.id,
          departmentId: empData?.employee_details?.department?.id ? empData?.employee_details?.department?.id : null,
          designationId: empData?.employee_details?.designation?.id ? empData?.employee_details?.designation?.id : null,
          designation_name: empData?.employee_details?.designation?.name ? empData?.employee_details?.designation?.name : null,
          stepkey: key ? parseInt(key) : 0
        }
      })
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : ""
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: pagination.current,
      pageSize: pagination.pageSize || prevFilter.pageSize,
      query: queryRef.current,
      sorting: sortQuery,
    }));
    setSorting(sortQuery)
  }

  // filter start
  const renderFilter = (data) => {
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: 1,
      pageSize: pageSize || prevFilter?.pageSize,
      query: `designation=${data.designation_name !== undefined ? data.designation_name : ""}&status=${data.is_active ? data.is_active : ""}&department=${data.department_name !== undefined ? data.department_name : ""}&reporting_manager=${data.reporting_manager !== undefined ? data.reporting_manager : ""}&employee_group=${data.emplyee_group !== undefined ? data.emplyee_group : ""}`,
      search: searchText,
      sorting: sorting,
    }));
    setFilterVisible(false);
  }

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = (data) => {
    setFilterDatas((prevState) => ({
      ...prevState,
      ...initialData,
      designationList: data.designationList.length > 0 ? data.designationList : [],
      departmentlist: data.departmentlist.length > 0 ? data.departmentlist : [],
      reportingManagerList: data.reportingManagerList.length > 0 ? data.reportingManagerList : [],
      employeeGroupList: data.employeeGroupList.length > 0 ? data.employeeGroupList : []
    }));
    setPageNo(1);
    setFilter(1,
      pageSize,
      query,
      searchText,
      sorting);
  }
  //filter end

  const columns = [
    {
      title: "Candidate Details",
      dataIndex: "employee_details",
      key: "employee_details__employee_name",
      width: "22.5%",
      sorter: true,
      fixed: "left",
      render: (_, record) => {
        let empDetails = {
          ...record.employee_details,
          "profile": record?.employee_details?.profile ? record?.employee_details.profile : "",
          "designation_id": record?.employee_details?.designation?.id ? { ...record, id: record?.employee_details.designation.id, designation_name: record?.employee_details?.designation?.name } : { id: 0, designation_name: "" },
          "id": record?.employee_details.employee_id ? record?.employee_details.employee_id : "",
          'first_name': record?.employee_details.employee_name
        }
        return (
          <span
            onClick={() => handleClick(record)}
            style={{ color: record.is_active ? "black" : "#CACACA", cursor: "pointer" }}
          >
            <EmployeeDetails details={empDetails} />
          </span>
        )
      }
    },
    {
      title: "Applied For",
      dataIndex: "applied_for",
      key: "employee_details__designation__name",
      sorter: true,
      width: "14%",
      fixed: "left",
      render: (_, record) => {
        return (record?.employee_details?.designation?.name?.length > 30 ?
          <Tooltip title={record?.employee_details?.designation?.name}>{<span style={{ color: "black" }}>{record?.employee_details?.designation?.name?.slice(0, 30) + "..."}</span>}</Tooltip>
          : <p style={{ color: "black" }}>{record?.employee_details?.designation?.name ? record?.employee_details?.designation?.name : "-"}</p>)
      }
    },
    {
      title: "Registered Date",
      dataIndex: "registered_date",
      key: "registered_date",
      sorter: true,
      width: "14%",
      render: (_, record) => (<span style={{ color: record.is_active ? "black" : "#CACACA" }}>{record?.registered_date ? dayjs(record.registered_date, "YYYY-MM-DD").format("DD-MM-YYYY") : "-"}</span>),
      align: 'center',
      fixed: "left",
    },
    {
      title: "Registered By",
      dataIndex: "registered_by",
      key: "registered_by",
      sorter: true,
      width: "17%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record?.registered_by?.length > 20 ?
          <Tooltip title={record?.registered_by}>{<span style={{ color: colors }}>{record?.registered_by?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record?.registered_by ? record?.registered_by : "-"}</p>)
      }
    },
    {
      title: "Stage",
      dataIndex: "stage",
      key: "stage",
      width: "16%",
      sorter: true,
      fixed: "left",
      render: (_, record) => {
        return (record?.stage?.length > 30 ?
          <Tooltip title={record?.stage}>{<span style={{ color: "black" }}>{record?.stage?.slice(0, 30) + "..."}</span>}</Tooltip>
          : <p style={{ color: "black" }}>{record?.stage ? record?.stage : "-"}</p>)
      }
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      sorter: true,
      width: "13%",
      render: (_, record) => {
        return (record?.status?.length > 30 ?
          <Tooltip title={record?.status}>{<span style={{ color: "black" }} className="capitalize">{record?.status?.slice(0, 30) + "..."}</span>}</Tooltip>
          : <p style={{ color: "black" }} className="capitalize">{record?.status ? record?.status : "-"}</p>)
      },
      align: 'center',
      fixed: "left",
    },
  ];

  columns.push({
    title: "Action",
    key: "action",
    align: 'center',
    width: "7.5%",
    fixed: "left",
    render: (_, record) => {
      const items = [
        {
          key: "1",
          label: (<div className="empApproveTxt">Documents</div>)
        },
        {
          key: "2",
          label: (<div className="empApproveTxt">Salary Info</div>)
        },
        {
          key: "3",
          label: (<div className="empApproveTxt">Final Step</div>)
        },
      ];
      return (
        <div className="flex justify-center items-center">
          <Space size={"middle"}>
            <Dropdown menu={{
              items,
              onClick: ({ key }) => {
                handleClick(record, key)
              }
            }} trigger={['click']} placement="bottomLeft">
              <IconButton title="" icon={<img src={ImagePaths.moreIcon.default} alt="more" />} />
            </Dropdown>
          </Space>
        </div>
      )
    }
  })

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const queryString =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&designation=" + (filterDatas.designation_name ? filterDatas.designation_name : "") +
    "&department=" + (filterDatas.department_name ? filterDatas.department_name : "") +
    "&reporting_manager=" + (filterDatas.reporting_manager ? filterDatas.reporting_manager : "") +
    "&employee_group=" + (filterDatas.emplyee_group ? filterDatas.emplyee_group : "") +
    "&status=" + (filterDatas.is_active !== undefined ? filterDatas.is_active : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  return (
    <Card className="h-full overflow-hidden">
      <div className={"h-1/6"} >
        <CommonTblHeader pageName={"Employee Onboarding"}
          pageInfo={pageInfo}
          handleSearch={handleSearch} addClick={addClick}
          onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          url={NEW_EMPLOYEE_CANDIDATE_INFO} query={queryString}
          isAddRequired={isEditAccess ? true : false} isDraftRequired={false} addBtnLabel={"New Candidate"}
          isFltRequired={false}
        />
      </div>
      <div className="h-5/6 flex justify-center items-center  mt-1">
        {filterVisible ?
          <div className="w-1/4 mt-5" style={styles.fltContainer}>
            <EmployeeFilter
              pageName={"Employees"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
          <Table
            columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
            dataSource={data?.length > 0 ? data : null}
            loading={loading}
            style={{ "--table-container-height": tableContainerHeight }}
            scroll={{ y: `calc(${tableContainerHeight} - 140px)` }}
            onChange={handleTableChange}
            pagination={{
              style: { marginRight: 20, padding: 0 },
              defaultPageSize: pageSize,
              showSizeChanger: false,
              showQuickJumper: true,
              total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
              pageSizeOptions: ["10", "20", "30"],
              pageSize,
              defaultCurrent: pageNo,
            }}
            key={dataUpdated ? "updated" : "not-updated"}
          />
        </div>
      </div>
    </Card>
  );
}

export default EmployeeOnboardingList;
